import { Link } from "react-router-dom";
import { DateAvatar } from "@circle-react/components/Events/DateAvatar";
import { Typography } from "@circle-react/components/shared/uikit/Typography";
import { getLocalizedTimeRange } from "@circle-react/helpers/dateTimeHelpers/getLocalizedRange";

export interface UpcomingEventProps {
  endsAt: string;
  eventName: string;
  showPath: string;
  startDate: string;
  startsAt: string;
  timeZone: string;
  timeZoneAbbreviation: string;
}

export const UpcomingEvent = ({
  endsAt,
  eventName,
  showPath,
  startDate,
  startsAt,
  timeZone,
  timeZoneAbbreviation,
}: UpcomingEventProps) => {
  const startsAtDate = new Date(startsAt);
  const endsAtDate = new Date(endsAt);

  const localizedTimeRange = getLocalizedTimeRange(
    startsAtDate,
    endsAtDate,
    timeZone,
  );

  return (
    <li>
      <div className="flex gap-4">
        <div>
          <DateAvatar dateString={startDate} isSquare />
        </div>
        <div className="flex w-full items-center">
          <Link to={showPath} className="flex w-full flex-col gap-1">
            <div className="flex overflow-hidden text-ellipsis">
              <Typography.LabelSm weight="semibold">
                {eventName}
              </Typography.LabelSm>
            </div>
            <div className="flex">
              <Typography.LabelXs color="text-light">
                {`${localizedTimeRange} ${timeZoneAbbreviation}`}
              </Typography.LabelXs>
            </div>
          </Link>
        </div>
      </div>
    </li>
  );
};
